<template>
  <section class="hero is-info">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">ご利用ありがとうございました</h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "thanks"
};
</script>
